import styled from "styled-components";
import { colors, text } from "~/assets/js/theme/constants";

const ListCaption = styled.div`
    text-transform: ${text.TAGLINE.TRANSFORM};
    font-weight: ${text.TAGLINE.WEIGHT};
    font-size: 16px;
    line-height: 16px;
    color: ${colors.LAYOUT.GRAY[500]};
    font-family: ${text.TAGLINE.FONT};
    letter-spacing: 1px;
    padding: 12px 0 0 12px;
`;

export default ListCaption;
